import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateInternshipPlans = () => {
  const transform = data => {
    const { isWards, ...rest } = data;
    if (isWards || rest.isMonthlyInternship) {
      return { ...rest, disciplines: [] };
    }

    return { ...rest, wards: [] };
  };

  return (
    <Create
      title="Създаване на стажантски план"
      actions={<BackButtonToolbar />}
      transform={transform}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateInternshipPlans;
